/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { ICodeableConcept } from '@ahryman40k/ts-fhir-types/lib/R4';

/** FHIR R4 makes CodeableConcept.text optional, so fall back to the first coding display. */
export function getCodeableConceptText(concept: ICodeableConcept | undefined): string | undefined {
  return (
    concept?.text?.trim() ||
    concept?.coding?.map((coding) => coding.display?.trim()).find((display) => !!display) ||
    undefined
  );
}
